// Local imports
import { toggle_slide, slide_up, scroll } from '../util/animation.js';

function init_shared(global) {
    let doc = global.document;
    let data_div = doc.querySelector('.sponsorship-data');
    let mobile_toggler = doc.querySelector('.revealToggle-mobileToggle');
    let shared = {
        data_div,
        mobile_toggler,
        container: doc.querySelector('.filtersBlock'),
        revealed_class: 'revealToggle--revealed',
        sponsorship_slider: doc.querySelector('.sponsorshipSlider'),
        page_content: doc.querySelector('.sponsorPage'),
        site_footer: doc.querySelector('.siteFooter'),
        close_button: doc.querySelector('.filtersBlock-closeFilters'),
        reveal_button_class: 'filtersBlock-closeFilters--in',
        mobile_text_target: mobile_toggler.querySelector('.js-change'),
        all_mobile_hider_div: doc.querySelectorAll('.revealToggle-mobileHide'),
        mobile_hide_text: data_div.dataset.hideMobile,
        mobile_show_text: data_div.dataset.showMobile,
    };
    return shared;
}

export function initialize(global) {
    let shared = init_shared(global);
    init_desktop_toggle_handler(global, shared);
    init_mobile_toggle_handler(global, shared);
    init_close_handler(shared);
}

function init_desktop_toggle_handler(global, shared) {
    let doc = global.document;
    let toggler = doc.querySelector('.revealToggle-toggle');
    let text_target = toggler.querySelector('.js-change');
    let hider = doc.querySelector('.revealToggle-hide');
    let data_div = shared.data_div;
    let container = shared.container;
    let revealed_class = shared.revealed_class;

    let show_text = data_div.dataset.show;
    let hide_text = data_div.dataset.hide;

    toggler.addEventListener('click', event => {
        event.preventDefault();
        let filtersBlockTogglerText = doc.querySelector(
            '.filtersBlock-deskTogglerText'
        );

        if (container.classList.contains(revealed_class)) {
            text_target.textContent = show_text;
            filtersBlockTogglerText.setAttribute('aria-expanded', 'false');
        } else {
            text_target.textContent = hide_text;
            filtersBlockTogglerText.setAttribute('aria-expanded', 'true');
        }

        container.classList.toggle(revealed_class);
        toggle_slide(hider);
    });
}

function init_mobile_toggle_handler(global, shared) {
    shared.mobile_toggler.addEventListener(
        'click',
        mobile_toggler_event_handler
    );
    shared.mobile_toggler.addEventListener(
        'keypress',
        mobile_toggler_event_handler
    );

    function mobile_toggler_event_handler(event) {
        let container = shared.container;
        let revealed_class = shared.revealed_class;
        let filtersBlockMobileToggler = global.document.querySelector(
            '.filtersBlock-mobileTogglerText'
        );

        if (event.which === 13 || event.type === 'click') {
            if (container.classList.contains(revealed_class)) {
                // This first branch means the toggle button has been clicked to
                // show the filters. revealToggle.js triggers first which is why the
                // container has the revealToggle--revealed class
                shared.mobile_text_target.textContent = shared.mobile_hide_text;
                show_search_button(shared);
                filtersBlockMobileToggler.setAttribute('aria-expanded', 'true');
            } else {
                // This second branch means the toggle button has been clicked to
                // hide the filters.
                hide_search_button(shared);
                shared.mobile_text_target.textContent = shared.mobile_show_text;
                filtersBlockMobileToggler.setAttribute(
                    'aria-expanded',
                    'false'
                );
            }
        }
    }
}

function init_close_handler(shared) {
    shared.close_button.addEventListener('click', () => {
        hide_search_button(shared);
        shared.mobile_text_target.textContent = shared.mobile_show_text;
        shared.container.classList.remove(shared.revealed_class);
        for (let mobile_hider_div of shared.all_mobile_hider_div) {
            slide_up(mobile_hider_div);
        }
        scroll(document.body, 0);
    });
}

function hide_search_button(shared) {
    shared.close_button.classList.remove(shared.reveal_button_class);
}

function show_search_button(shared) {
    shared.close_button.classList.add(shared.reveal_button_class);
}
